module.exports = __webpack_public_path__ + "img/大数据一体化解决方案.67aa58c1.jpg";